import { useCallback, useRef } from 'react';

type RowWithOptionalId = {
  id?: string | null;
};

export const useStableRowId = <T extends RowWithOptionalId>(prefix: string) => {
  const fallbackRowIdsRef = useRef(new WeakMap<object, string>());

  const generateSecureFallbackId = useCallback((): string => {
    const values = new Uint32Array(2);
    globalThis.crypto.getRandomValues(values);
    return `${prefix}-missing-id-${values[0].toString(36)}-${values[1].toString(36)}`;
  }, [prefix]);

  return useCallback((row: T): string => {
    if (row.id) {
      return row.id;
    }

    const rowObject = row as object;
    const existingId = fallbackRowIdsRef.current.get(rowObject);
    if (existingId) {
      return existingId;
    }

    const generatedId = generateSecureFallbackId();
    fallbackRowIdsRef.current.set(rowObject, generatedId);
    return generatedId;
  }, [generateSecureFallbackId]);
};
